import * as React from 'react';
import { MessageBanner } from 'client/ui/message-banner/MessageBanner';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { LogoutButton } from 'client/components/auth/logout/LogoutButton';

export interface AdminFrontBannerProps {}
/**
 * Messaggio di avviso per l'utente amministratore che visualizza il frontend.
 */
export function AdminFrontBanner(props: AdminFrontBannerProps) {
  const user = useCurrentUser();
  if (!user || (user && user.citizenId)) return null;

  return (
    <MessageBanner>
      <div style={{ textAlign: 'center' }}>
        Stai visualizzando il Portale in modalità Amministratore con
        funzionalità per il Cittadino disabilitate.{' '}
        <Link to="/admin/procedures/">
          <Button size="small" children="Vai al Backend" />
        </Link>{' '}
        <Button
          size="small"
          children={<LogoutButton hideIcon text="Admin Logout" />}
        />
      </div>
    </MessageBanner>
  );
}
